import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { FIRST_PAGE, MAX_PER_PAGE } from 'constants/constants';
import { InvoicePage, QueryInvoicesArgs } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import { buildQueryKey } from 'utils/buildQueryKey';
import clientUtil from 'utils/clientUtil';

type TVariables = QueryInvoicesArgs;
type TData = InvoicePage;

const MOCK: TVariables = {
  overdue: undefined,
  page: FIRST_PAGE,
  paid: undefined,
  perPage: MAX_PER_PAGE,
  skipPagination: undefined,
  sortAttribute: undefined,
  sortOrder: undefined
};

export const useInvoices = (
  variables: TVariables = MOCK,
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query invoices(
      $sortAttribute: InvoiceSortAttributeEnum
      $sortOrder: SortOrderEnum
      $page: Int
      $perPage: Int
    ) {
      invoices(
        sortAttribute: $sortAttribute
        sortOrder: $sortOrder
        page: $page
        perPage: $perPage
      ) {
        nodes {
          amount
          chamberOfCommerce
          createdAt
          issuedAt
          currency
          dueDate
          fromAddress
          id
          legacy
          netAmount
          overdue
          paid
          paymentMethod
          customerNumber
          poCode
          taxAmount
          taxId
          toAddress
        }
        nodesCount
        pagesCount
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['invoices', ...buildQueryKey({ ...MOCK, ...variables })],
    queryFn: async () =>
      await client.request({
        data: {
          gql: graphql,
          variables
        }
      })
  });
};
